module.exports = __webpack_public_path__ + "img/kennot.2031432c.png";